import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Target from '@nerdwallet/react-icon/gizmo/Target';
import classNames from 'classnames';

import { moveComponent } from '../builder/actions';

class Dropzone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      on: false,
    };
  }

  render() {
    const { name, dispatch, sortingComponentId, targetId } = this.props;

    return (
      <a
        className={classNames({
          'editor-control__dropzone': true,
          'editor-control__dropzone-on': this.state.on,
          'editor-control__dropzone-visible': sortingComponentId,
        })}
        title={`Above ${name}`}
        onDragEnter={() => {
          this.setState({ on: true });
        }}
        onDragLeave={() => {
          this.setState({ on: false });
        }}
        onDragOver={(evt) => {
          // this lets the browser know this is a valid drop zone
          evt.preventDefault();
        }}
        onDrop={() => {
          if (sortingComponentId) {
            dispatch(moveComponent(sortingComponentId, targetId));
          }
        }}
      >
        {sortingComponentId ? <Target /> : null}
      </a>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
Dropzone.propTypes = {
  targetId: PropTypes.string.isRequired,
  name: PropTypes.string,
  sortingComponentId: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
Dropzone.defaultProps = {
  sortingComponentId: '',
};

export default Dropzone;
